var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pick-plan"},_vm._l((_vm.plans),function(plan,index){return _c('pick-plan-card',{key:index,attrs:{"plan":plan},on:{"plan-picked":(plan) => _vm.$emit('plan-picked', plan)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }